import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { Business, TENANT, Vertical, Zone, TENANTS } from "../../config/constant";
import { toast } from "react-toastify";
import { MasterService } from "../../services";
import Loader from "../common/loader";
import 'react-tippy/dist/tippy.css'


const RoleUserDetail = () => {
    const [loading, setLoading] = useState(false);
    const [roleDetails, setRoleDetails] = useState({});
    const [roleNameList, setRoleNameList] = useState([]);
    const { role_id } = useParams();

    useEffect(() => {
        getRoleDetailsById(role_id);  
        // eslint-disable-next-line react-hooks/exhaustive-deps     
    }, [])

    useEffect(() => {
        document.addEventListener('mousedown', bodyClickState);
        document.addEventListener('mousedown', bodyClickCity);
        return () => {
            document.removeEventListener('mousedown', bodyClickState);
            document.removeEventListener('mousedown', bodyClickCity);
        };
    }, []);
    function bodyClickState(e) {       
    }

    function bodyClickCity(e) {      
    }

    const getRoleList = async () => {
        try {
            let response = await MasterService.post('/sfa/user/role_list', {});
            if (response.status === 200) {
                let roleList = response.data.data;
                setRoleNameList(roleList);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const getRoleDetailsById = (id) => {
        setLoading(true);
        MasterService.post('/sfa/role/get_role_view', { 'role_id': id })
            .then(async (response) => {
                if (response.data.status === 200) {
                    response.data.data.business_unit = Business;
                    response.data.data.business_vertical = Vertical;
                    response.data.data.zone_id = Zone;
                    // await getCityList();
                    // await getStateList();
                    setRoleDetails(response.data.data);
                    await getRoleList();
                    setLoading(false);
                } else {
                    toast.error(response.data.message)
                    setLoading(false);
                }
            })
            .catch((err) => {
                toast.error(err)
                setLoading(false);
            })
    }
const selectedBusinessValue =
  TENANT === TENANTS.PH
    ? Business.find(item => item.id === 1)?.value
    : Business.find(
        item => item.id === roleDetails?.business_unit_id
      )?.value;
    return (
        <React.Fragment>
            {loading ? <Loader /> : null}
            <div className="container-fluid">
                <div className="top-bar">
                    <div className="top-heading d-flex">
                        <h1>Role Details</h1>
                        <div className="right-btn btn-agent-detail">
                           {/*  <button className="btn-line m-xs-l">
                                <i
                                    className="ic-edit"
                                    onClick={() => { handleEdit( `/edit-role/role_details_info?id=${role_id}`); }}
                                ></i>{" "}
                                Edit
                            </button> */}
                        </div>
                    </div>
                </div>
                <div className="agent-detail-tads role-detail-tabs">
                    <div className="preview-confirmation add-user-detail-filed">
                        <div className="top-heading d-flex br-radius">
                            <h2>Role Details</h2>
                            {/* <a href="" className="edit-opt" onClick={() => { handleEdit(`/edit-role/role_details_info?id=${role_id}`) }}>
                                Edit
                            </a> */}
                        </div>

                        <div className="d-flex">
                            <div className="role-detail-preview">
                                <h3>Business Vertical</h3>
                                <ul>
                                    <li>
                                        <span>Business</span>
                                        <label>
                                            {selectedBusinessValue}                                         
                                        </label>
                                    </li>
                                    <li>
                                        <span>Vertical</span>
                                        <label>
                                            {roleDetails &&
                                                roleDetails.business_vertical &&
                                                roleDetails.business_vertical.map(
                                                    (item) => item.label
                                                )}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="d-flex m-xl-t p-sm-t m-xl-b p-md-b">
                            <div className="role-detail-preview role-informatiom">
                                <h3>Role Information</h3>
                                <ul>
                                    <li>
                                        <span>Role name</span>
                                        <label>
                                            {roleDetails &&
                                                roleDetails.role_name &&
                                                roleDetails.role_name}
                                        </label>
                                    </li>
                                    <li>
                                        <span>Status</span>
                                        <label>
                                            {roleDetails &&
                                                roleDetails.role_status &&
                                                roleDetails.role_status === "1"
                                                ? "Active"
                                                : "Inactive"}
                                        </label>
                                    </li>
                                    {/* <li>
                                        <span>Digital Consultant</span>
                                        <label>
                                            {roleDetails.digital_consultant &&
                                                roleDetails.digital_consultant ===
                                                "1"
                                                ? "Activate"
                                                : "Deactivate"}
                                        </label>
                                    </li> */}
                                    <li>
                                        <span>Role Discription</span>
                                        <label>
                                            {roleDetails &&
                                                roleDetails.role_description &&
                                                roleDetails.role_description}
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>                       
                        <div className="d-flex">
                            <div className="role-detail-preview preview-basic-details">
                                <h3>Rights Detail</h3>
                                <ul>
                                    {(TENANT !== TENANTS.PH) &&
                                    <li>
                                        <span>Report of Role </span>
                                        <label>
                                            {(roleNameList && roleDetails?.reporting_from && roleNameList
                                                .filter((role) => roleDetails.reporting_from.includes(role.id))
                                                .map((item) => item.name)
                                                .join(",")) || "-"}
                                        </label>
                                    </li>
                                    }
                                    <li>
                                        <span>View Report of</span>
                                        <label>
                                            {roleNameList
                                                .filter((role) => roleDetails.reporting_to.includes(role.id))
                                                .map((item) => item.name)
                                                .join(",")}
                                        </label>
                                    </li>                                    
                                </ul>
                            </div>
                        </div>                      
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default RoleUserDetail;
